var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.8163 0.220207L6.19095 0.821336C6.03462 0.979529 6.03462 1.23264 6.19095 1.35919L11.0374 6.26314H0.375209C0.156337 6.26314 0 6.45297 0 6.64281V7.52868C0 7.75015 0.156337 7.90834 0.375209 7.90834H11.0374L6.19095 12.8439C6.03462 12.9705 6.03462 13.2236 6.19095 13.3818L6.8163 13.9829C6.94137 14.1411 7.19151 14.1411 7.34785 13.9829L13.8827 7.37049C14.0391 7.2123 14.0391 6.99083 13.8827 6.83264L7.34785 0.220207C7.19151 0.0620145 6.94137 0.0620145 6.8163 0.220207Z",
    fill: "#36424E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowRight);
export default __webpack_public_path__ + "static/media/ic-arrow-right.c82b77b2b1a2f4c84535ec6b2e166194.svg";
export { ForwardRef as ReactComponent };